import React from 'react';
import { Input } from "antd";

import { FormItem } from 'utils';
import { SimpleFileField } from 'components/common/fields';


const MainFieldSet = (props) => {
  return (
    <div className="form-block">
      <FormItem {...props} name="name" label="Название" required={true}>
        <Input size="large"/>
      </FormItem>

      <SimpleFileField {...props} name="tpl_file" label="Файл" required={true}/>
    </div>
  );
};

export default MainFieldSet;
